import * as React from 'react'
import { FC } from 'react'
import { Formik } from 'formik'

import { EditOpportunityNameFormFields } from './EditOpportunityNameFormFields'
import { IOpportunityDetail } from '@user/store/opportunity/typings'
import { useSelector } from 'react-redux'
import { selectAllLeadOppProducts } from '@user/store/leadOppProducts/slice'
import { useHandlers } from './hooks'

interface Props {
  detail: IOpportunityDetail
  onClose: () => void
}

export interface EditOpportunityNameFormModel {
  opportunityName: string
  useSystemName: string
}

export const EditOpportunityNameFormWrapper: FC<Props> = (props) => {
  const { detail, onClose } = props

  const services = useSelector(selectAllLeadOppProducts)

  const { validate, onSubmit } = useHandlers({
    id: detail.id,
    onClose,
    services,
  })

  return (
    <Formik
      initialValues={{
        opportunityName: detail.opportunityName,
        useSystemName: detail.useSystemName.toString(),
      }}
      onSubmit={onSubmit}
      validate={validate}
    >
      <EditOpportunityNameFormFields
        initialValue={detail.opportunityName}
        onCancel={onClose}
        services={services}
      />
    </Formik>
  )
}

EditOpportunityNameFormWrapper.displayName = 'EditOpportunityNameFormWrapper'
